import { ngRoute } from '../../../../app/routing/ngRoute';

angular.module('signalview.chartTemplates').factory('chartTemplates', [
    function () {
        const templates = {};

        const service = {
            register: function (name, template) {
                templates[name] = template;
            },
            get: function (name) {
                return templates[name];
            },
            fromUrl: function () {
                let templateChart = null;
                const filters = {};
                if (ngRoute.params.filters) {
                    let filtersArray = ngRoute.params.filters;

                    if (angular.isString(filtersArray)) filtersArray = [filtersArray];

                    filtersArray.forEach(function (filter) {
                        // Split key:value
                        if (!filter) return;

                        const parts = filter.split(':');
                        const key = parts[0];
                        const value = parts.splice(1).join(':');

                        // Support multiple values for the same key (especially sf_metric)
                        if (filters[key]) {
                            // Convert to array if not already
                            if (!angular.isArray(filters[key])) {
                                filters[key] = [filters[key]];
                            }
                            filters[key].push(value);
                        } else {
                            filters[key] = value;
                        }
                    });
                }

                if (ngRoute.params.template) {
                    const template = service.get(ngRoute.params.template);
                    templateChart = template(filters);
                }

                return templateChart;
            },
        };
        return service;
    },
]);
